import { prop, uniqBy } from 'ramda';
import PcModelOptionsGroupList from '../PcModelOptionsSubGroupList';

const PcModelOptionsSubGroupLists = ({
  groupType,
  subGroups,
  selectedSubGroup,
  options,
}) => {
  if (subGroups.length === 0) {
    return <PcModelOptionsGroupList groupType={groupType} options={options} />;
  }

  if (selectedSubGroup) {
    return (
      <PcModelOptionsGroupList
        groupType={groupType}
        subGroup={selectedSubGroup}
        options={options}
      />
    );
  }
  const sortedList = uniqBy(prop('option_sub_group_id'), subGroups).sort(
    (a, b) => a.priority - b.priority,
  );
  return sortedList.map((subGroup, k) => (
    <PcModelOptionsGroupList
      key={`${subGroup.sub_group_name}-${k}`}
      groupType={groupType}
      subGroup={subGroup}
      options={options}
    />
  ));
};

export default PcModelOptionsSubGroupLists;
